import { Component, inject } from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, Validators} from "@angular/forms";
import {TranslationService} from "../../../core/services/translation.service";
import {AddressListItem} from "../../../data/models/address-list.model";
import {RedirectService} from "../../../data/services/redirect.service";
import {HupSubscriptionsService} from "../../../data/services/hup-subscriptions.service";
import {SnackbarService} from "../../../core/services/snackbar.service";
import {Router} from "@angular/router";
import {GeneralErrorsComponent} from "../../../core/components/general-errors/general-errors.component";

import {LoadingSpinnerComponent} from "../../../core/components/loading-spinner/loading-spinner.component";
import {ClientSearchComponent} from "../../client-search/client-search.component";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {
  HupSubscriptionAddressComponent
} from "../../hup-subscription/hup-subscription-detail/hup-subscription-address/hup-subscription-address.component";
import {MatInput} from "@angular/material/input";
import {ContactComponent} from "../contact.component";
import {MatCard, MatCardContent} from "@angular/material/card";
import {ApplyIfNotEmptyDirective} from "../../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-contact-without-login',
  templateUrl: './contact-without-login.component.html',
  styleUrls: ['./contact-without-login.component.css'],
  imports: [
    GeneralErrorsComponent,
    LoadingSpinnerComponent,
    ClientSearchComponent,
    MatError,
    HupSubscriptionAddressComponent,
    MatFormField,
    MatInput,
    FormsModule,
    ContactComponent,
    MatLabel,
    MatHint,
    MatCard,
    MatCardContent,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class ContactWithoutLoginComponent {
  private formBuilder = inject(FormBuilder);
  translationService = inject(TranslationService);
  private redirectService = inject(RedirectService);
  private subscriptionService = inject(HupSubscriptionsService);
  private snackBar = inject(SnackbarService);
  private router = inject(Router);


  clientNoForm: FormGroup;
  addressForm: FormGroup;
  errorsArr: string[] = [];
  isLoading: boolean = false;
  isFirst: boolean = true;
  clientFound: boolean = false;
  customer: AddressListItem;
  emailExists: boolean = false;
  emailAddress: string;
  constructor() {
    this.clientNoForm = this.formBuilder.group({
      clientNo: ['', Validators.required]
    });

    this.addressForm = this.formBuilder.group({
      contactAddress: this.formBuilder.group({
        showAddress: [''],
        address: this.formBuilder.group({
          country: [''],
          zipcode: [''],
          city: [''],
          street: [''],
          houseNo: [''],
          extraLine: [''],
          houseNoExt: [''],
          stiege: [''],
          stock: [''],
          tuer: [''],
          district: [''],
        }),
        person: this.formBuilder.group({
          title: [''],
          salutation: [''],
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          initials: [''],
          middlename: [''],
        })
      })
    });
  }

  loadCustomerByClientNo(clientno): void {
    if( clientno && clientno > 0) {
      this.isLoading = true;
      this.subscriptionService.getCustomerUnauthorized(clientno).subscribe(customer => {
        if (customer) {
          this.customer = customer;
          this.clientFound = true;
          if (customer.emailList && customer.emailList.length > 0) {
            this.emailExists = true;
          }
        } else {
          this.clientFound = false;
        }
        this.isFirst = false;
        this.isLoading = false;
      });
    } else {
      this.clientFound = false;
      this.isFirst = true;
    }
  }

  savedRequest(saved: boolean) {
    this.addressForm.reset();
    this.emailAddress = "";
    this.router.navigate(['/contact']).then((navigated) => {
      if (navigated) {
        this.snackBar.openSnackbar(this.translationService.getTranslation("contact_unauthorized_saved"));
      }
    });
  }

  protected readonly document = typeof document === 'object' ? document : null;
}
